import {
  PACKING_TYPE,
  PRODUCT_CREATE,
  PRODUCT_DELETE,
  PRODUCT_DETAIL,
  PRODUCT_EDIT,
  PRODUCT_ENABLE_DESABLE,
  PRODUCT_LIST,
  PRODUCT_VERSION_DETAIL,
  PRODUCT_VERSION_LIST,
  VENDOR_DIVISION_LIST,
  FETCH_HEADQUATER_LIST,
  FETCH_DOCTOR_LIST,
  FETCH_PHARMACY_LIST,
  PRODUCT_VIEW_DOCTOR_LIST,
  PRODUCT_VIEW_PHARMACY_LIST,
  PRODUCT_DOCTOR_OFFERS_REQUEST,
  PRODUCT_PHARMACY_OFFERS_REQUEST,
  FETCH_ADD_PHARMACY_LIST,
  FETCH_ADD_DOCTOR_LIST,
  PRODUCT_ADD_DOCTOR,
  PRODUCT_ADD_PHARMACY,
} from "./types";

export const packingTypeList = (onSuccess, onError) => {
  return {
    type: PACKING_TYPE,
    onSuccess,
    onError,
  };
};

export const productList = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const productDetail = (id, onSuccess, onError) => {
  return {
    type: PRODUCT_DETAIL,
    id,
    onSuccess,
    onError,
  };
};

export const productCreate = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const productEdit = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const productEnableDisable = (id, onSuccess, onError) => {
  return {
    type: PRODUCT_ENABLE_DESABLE,
    id,
    onSuccess,
    onError,
  };
};

export const productDelete = (id, onSuccess, onError) => {
  return {
    type: PRODUCT_DELETE,
    id,
    onSuccess,
    onError,
  };
};

export const productVersionList = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_VERSION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const productVersionDetail = (id, onSuccess, onError) => {
  return {
    type: PRODUCT_VERSION_DETAIL,
    id,
    onSuccess,
    onError,
  };
};
export const vendorDivisionList = (onSuccess, onError) => {
  return {
    type: VENDOR_DIVISION_LIST,
    onSuccess,
    onError,
  };
};

export const fetchHeadQuaterList = (onSuccess, onError) => {
  return {
    type: FETCH_HEADQUATER_LIST,
    onSuccess,
    onError,
  };
};

export const fetchDoctorList = (id, onSuccess, onError) => {
  return {
    type: FETCH_DOCTOR_LIST,
    id,
    onSuccess,
    onError,
  };
};
export const fetchPharmacyList = (id, onSuccess, onError) => {
  return {
    type: FETCH_PHARMACY_LIST,
    id,
    onSuccess,
    onError,
  };
};

export const fetchAddDoctorList = (onSuccess, onError) => {
  return {
    type: FETCH_ADD_DOCTOR_LIST,

    onSuccess,
    onError,
  };
};
export const fetchAddPharmacyList = (onSuccess, onError) => {
  return {
    type: FETCH_ADD_PHARMACY_LIST,
    onSuccess,
    onError,
  };
};

export const productViewDoctorList = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_VIEW_DOCTOR_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const productViewPharmacyList = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_VIEW_PHARMACY_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const productDoctorsOfferRequest = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_DOCTOR_OFFERS_REQUEST,
    data,
    onSuccess,
    onError,
  };
};
export const productPharmacyOfferRequest = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_PHARMACY_OFFERS_REQUEST,
    data,
    onSuccess,
    onError,
  };
};

export const productAddDoctorsRequest = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_ADD_DOCTOR,
    data,
    onSuccess,
    onError,
  };
};
export const productAddPharmacyRequest = (data, onSuccess, onError) => {
  return {
    type: PRODUCT_ADD_PHARMACY,
    data,
    onSuccess,
    onError,
  };
};
